import { CalendarDays, Phone } from "lucide-react";
import { useLocation } from "wouter";

export function MobileBookingBar() {
  const [path] = useLocation();
  if (path.replace(/\/+$/, "") === "/commandcenter") return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 p-3 shadow-[0_-4px_18px_rgba(0,0,0,0.12)] backdrop-blur md:hidden">
      <div className="mx-auto flex max-w-lg gap-2">
        <a href="/book" className="flex min-h-12 flex-1 items-center justify-center gap-2 rounded-full bg-primary px-4 py-3 font-bold text-primary-foreground hover:bg-primary/90">
          <CalendarDays size={18} aria-hidden="true" /> Book a ride
        </a>
        <a href="tel:+16085793356" aria-label="Call Cycling Without Age McFarland" className="flex min-h-12 min-w-12 items-center justify-center rounded-full border border-primary px-4 py-3 font-bold text-primary hover:bg-primary/5">
          <Phone size={18} aria-hidden="true" /><span className="sr-only">Call</span>
        </a>
      </div>
    </div>
  );
}